const getEyeLabel = (intl, id)=>intl.getLabel(`products.${id === 'left' ? 'contactLenses.leftEye' : 'contactLenses.rightEye'}`)
;
const getAttributeLabel = (intl, attribute)=>intl.getLabel(`products.contactLenses.prescription.${attribute}`)
;

export { getAttributeLabel, getEyeLabel };
//# sourceMappingURL=utils.js.map
